var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66669 5.56253L7.42754 8.82667C9.55135 10.03 10.4487 10.03 12.5725 8.82667L18.3334 5.56253",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.67983 11.7922C1.7343 14.3469 1.76155 15.6241 2.70415 16.5704C3.64675 17.5165 4.95863 17.5495 7.58238 17.6154C9.19944 17.656 10.8006 17.656 12.4177 17.6154C15.0414 17.5495 16.3533 17.5165 17.2959 16.5704C18.2385 15.6241 18.2658 14.3469 18.3202 11.7922C18.3378 10.9708 18.3378 10.1543 18.3202 9.33287C18.2658 6.77825 18.2385 5.50094 17.2959 4.55475C16.3533 3.60856 15.0414 3.5756 12.4177 3.50968C10.8006 3.46904 9.19944 3.46904 7.58237 3.50967C4.95863 3.57559 3.64675 3.60854 2.70415 4.55474C1.76154 5.50094 1.7343 6.77824 1.67982 9.33287C1.6623 10.1543 1.66231 10.9708 1.67983 11.7922Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.08f2eeaa5b43adad8efcc7929b2e443a.svg";
export { ForwardRef as ReactComponent };